var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepValid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "#3EC09C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5648 0.175926C17.3302 -0.058642 16.9784 -0.058642 16.7438 0.175926L7.88889 9.26543C7.65432 9.5 7.30247 9.5 7.0679 9.26543L3.19753 5.21913C3.08025 5.10185 2.90432 5.04321 2.78704 5.04321C2.61111 5.04321 2.49382 5.10185 2.37654 5.21913L0.675928 6.80247C0.558644 6.91975 0.5 7.09568 0.5 7.21296C0.5 7.38889 0.558644 7.56481 0.675928 7.6821L4.60494 11.9043C4.83951 12.1389 5.19136 12.5494 5.42593 12.7839L7.12654 14.5432C7.36111 14.7778 7.71296 14.7778 7.94753 14.5432L19.3241 2.87346C19.5586 2.63889 19.5586 2.22839 19.3241 1.99383L17.5648 0.175926Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepValid);
export default __webpack_public_path__ + "static/media/step_valid.10376aef7730da8677ac346372e29b36.svg";
export { ForwardRef as ReactComponent };